// extracted by mini-css-extract-plugin
export var rightPanelOpenOld = "_43-0";